/*
 * Frecce sull'immagine principale della galleria prodotto (main-product).
 *
 * La galleria nativa del tema fa scorrere le immagini per scroll orizzontale
 * solo su mobile: da tablet in su mostra una sola slide attiva e il cambio
 * immagine passa esclusivamente dal click sulle miniature; i pulsanti
 * freccia nativi del visualizzatore principale sono pensati solo per quello
 * scroll mobile e restano rotti da desktop. Per questo qui non riusiamo
 * quei pulsanti: creiamo due frecce nuove, indipendenti, che si limitano a
 * simulare il click sulla miniatura successiva/precedente, riusando così il
 * comportamento nativo di cambio immagine già collaudato.
 */
(function () {
  function createArrow(direction) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'roji-gallery-arrow roji-gallery-arrow--' + direction;
    button.setAttribute(
      'aria-label',
      direction === 'prev' ? 'Immagine precedente' : 'Immagine successiva'
    );
    button.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      (direction === 'prev'
        ? '<polyline points="15 18 9 12 15 6"></polyline>'
        : '<polyline points="9 18 15 12 9 6"></polyline>') +
      '</svg>';
    return button;
  }

  function setupArrows(wrapper) {
    var gallery = wrapper.querySelector('media-gallery');
    if (!gallery) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var thumbButtons = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item button.thumbnail')
    );
    if (thumbButtons.length < 2) return;

    if (getComputedStyle(viewer).position === 'static') {
      viewer.style.position = 'relative';
    }

    var prevButton = createArrow('prev');
    var nextButton = createArrow('next');
    viewer.appendChild(prevButton);
    viewer.appendChild(nextButton);

    function currentIndex() {
      var index = thumbButtons.findIndex(function (button) {
        return button.getAttribute('aria-current') === 'true';
      });
      return index === -1 ? 0 : index;
    }

    function goTo(delta) {
      var index = currentIndex();
      var nextIndex = (index + delta + thumbButtons.length) % thumbButtons.length;
      thumbButtons[nextIndex].click();
    }

    prevButton.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(-1);
    });

    nextButton.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__media-wrapper').forEach(setupArrows);
  });
})();
